import { useMemo } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import SetPasswordForm from '../_shared/SetPasswordForm';

export default function AdminResetPassword() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  if (!token || token.length < 32) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-600 via-brand-700 to-brand-900 px-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <h1 className="text-lg font-semibold text-gray-900">Invalid or missing link</h1>
          <p className="text-sm text-gray-500 mt-2">Open the full link from your reset email, or request a new password reset.</p>
          <Link to="/admin/forgot-password" className="inline-block mt-6 text-brand-600 hover:underline text-sm">Request new link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-600 via-brand-700 to-brand-900 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Set a new password</h2>
          <p className="text-sm text-gray-500 mb-6">Choose a strong password for your Talent Hub account.</p>
          <SetPasswordForm
            token={token}
            endpoint="/auth/reset-password"
            redirectTo="/admin/login"
            recovery={
              <Link to="/admin/forgot-password" className="font-medium text-danger-800 underline hover:text-danger-900">
                Request a new reset link
              </Link>
            }
          />
        </div>
        <p className="text-center text-brand-200 text-sm mt-6">
          <Link to="/admin/login" className="text-white hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
